import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { persistReducer } from 'redux-persist'
import { routerReducer, routerMiddleware } from 'react-router-redux';

import thunk from 'redux-thunk';

import * as auth from './auth';
import * as campanha from './campanha';
import * as lista from './lista';
import * as mailing from './anexos';

import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native

export default function configureStore(history, initialState)
{
    const reducers = {
        auth: auth.reducer,
        campanha: campanha.reducer,
        lista: lista.reducer,
        mailing: mailing.reducer,   
    };

    const persistConfig = {
        key: 'root',
        storage: storage,
        blacklist: []
    }

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension)
    {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    const persistedReducer = persistReducer(persistConfig, rootReducer)

    return createStore(
        persistedReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
  );
}
